import React from 'react';
import withIcon from '../utilities/withIcon';

const IconGridCarets = () => {
  return (
    <g>
      <path d="M6.565 9c.111 0 .222.055.307.163.155.197.17.506.042.723l-.042.063-3.063 3.888-.05.054a.366.366 0 0 1-.525-.004l-.045-.05L.13 9.951.085 9.89a.68.68 0 0 1 0-.661l.042-.063.05-.053a.379.379 0 0 1 .26-.11V9h6.127zm9 0c.111 0 .222.055.307.163.155.197.17.506.042.723l-.042.063-3.063 3.888-.05.054a.366.366 0 0 1-.525-.004l-.045-.05-3.06-3.886-.043-.062a.68.68 0 0 1 0-.661l.042-.063.05-.053a.379.379 0 0 1 .26-.11V9h6.127zm-9-7c.111 0 .222.055.307.163.155.197.17.506.042.723l-.042.063-3.063 3.888-.05.054a.366.366 0 0 1-.525-.004l-.045-.05L.13 2.951.085 2.89a.68.68 0 0 1 0-.661l.042-.063.05-.053a.379.379 0 0 1 .26-.11V2h6.127zm9 0c.111 0 .222.055.307.163.155.197.17.506.042.723l-.042.063-3.063 3.888-.05.054a.366.366 0 0 1-.525-.004l-.045-.05-3.06-3.886-.043-.062a.68.68 0 0 1 0-.661l.042-.063.05-.053a.379.379 0 0 1 .26-.11V2h6.127z" />
    </g>
  );
};

export default withIcon(IconGridCarets);
